window.$ = window.jQuery = require('jquery');

(() => {
    if (!document.getElementById('applicationForm')) {
        return;
    }

    const email = document.getElementById('email');
    const emailConfirmation = document.getElementById('email_confirmation');

    emailConfirmation.addEventListener('paste', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });

    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        let forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        let validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {

                emailConfirmation.setCustomValidity(validateEmail(email, emailConfirmation));

                form.classList.add('was-validated');

                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    form.classList.remove('was-validated');
                }
            }, false);
        });
    }, false);

    function validateEmail(email, emailConfirmation) {
        return email.value === emailConfirmation.value ? '' : 'error';
    }
})();

